import axios from "axios";
import moment from "moment-jalaali";
import { ConvertShamsiToMiladi } from "../components/DateFunctions/DateFunctions";
import API_URL from "../config/apiConfig";
import SUB_API_URL from "../config/apiConfig";
const baseUrl = API_URL;
const hostTourSearchInFlight = new Map();
const cleanSearchList = (values = []) =>
  (values || []).filter((value) => value != null && value !== "" && value !== "تمامی شهرها");

// سرچ لیست اقامتگاه ها
export const HostTourSearchApi = async (searchData, options = {}) => {
  const token = localStorage.getItem("access_token");
  const payload = {
    title: searchData?.title === "all" ? "all" : searchData?.title || "all",
    start: searchData?.start ? ConvertShamsiToMiladi(searchData?.start) : "",
    end: searchData?.end ? ConvertShamsiToMiladi(searchData?.end) : "",
    count: searchData?.count || 0,
    Room: searchData?.room || 0,
    minprice: parseFloat(searchData?.minprice) || 0,
    maxprice: parseFloat(searchData?.maxprice) || 0,
    skip: searchData?.skip || 0,
    take: searchData?.take || 10,
    sort: searchData?.sort || 0,
    type: searchData?.type || 0,
    RolItemTourId: [],
    OtherItemTourId: [],
    AccommodationSpace: [],
    Locations: searchData?.locations || [],
    rate: cleanSearchList(searchData?.rate),
    typeHost: cleanSearchList(searchData?.typeHost),
    typeHostLoc: cleanSearchList(searchData?.typeHostLoc),
    RolItemTour: cleanSearchList(searchData?.rolItemTour),
    OtherItemTour: cleanSearchList(searchData?.otherItemTour),
    province: cleanSearchList(searchData?.province),
    city: cleanSearchList(searchData?.city),
    LastMinuteDiscounts: searchData?.LastMinuteDiscounts || false,
    InstantBooking: searchData?.InstantBooking || false,
    IsOrderDiscountPercent: searchData?.LastMinuteDiscounts ? true : false,
    isNeighbors: searchData?.isNeighbors || false,
    hostId: searchData?.hostId || null,
    includeFilters: searchData?.includeFilters ?? false,
    includeProvinces: searchData?.includeProvinces ?? false,
    includeProfileImage: searchData?.includeProfileImage ?? false,
  };

  // If the same filter fires twice (URL change + manual search), reuse the same network call.
  const requestKey = `${token || "anonymous"}:${JSON.stringify(payload)}`;
  if (hostTourSearchInFlight.has(requestKey)) {
    return await hostTourSearchInFlight.get(requestKey);
  }

  const request = axios
    .post(`${baseUrl}/HostTour/Search`, payload, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      signal: options.signal,
    })
    .then((response) => response.data)
    .catch((error) => {
      if (error?.code === "ERR_CANCELED") return { __canceled: true };
      console.log("type Error:", error?.response);
      return error?.response?.data;
    })
    .finally(() => hostTourSearchInFlight.delete(requestKey));

  hostTourSearchInFlight.set(requestKey, request);
  return await request;
};

export const getBlogList = async () => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await axios.post(
      `${API_URL}/Mag/List`,
      {
        take: 10,
        skip: 0,
        myTagId: null,
        categoryId: null,
        title: null,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    console.log(response?.data, "get  Blogs");
    return response.data;
  } catch (error) {
    console.log(error, "getSelectedBlog Error");
    return error?.response?.data;
  }
};

// سرچ استان شهر و اقاماتگاه براساس عنوان
export const HostTourSearchTitleApi = async (searchData) => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await axios.get(`${baseUrl}/HostTour/SearchTitle`, {
      params: {
        title: searchData?.title,
      },
      headers: {
        token: token, // Add the token to the request header
      },
    });
    // console.log(response, "response");
    return response.data; // Assuming your API returns data in the response
  } catch (error) {
    console.log("Error:", error?.response?.data);
    return error?.response?.data;
  }
};

// مقاصد محبوب
// این داده در App و Home تقریباً همزمان درخواست می‌شود؛ یک cache کوتاه از درخواست تکراری جلوگیری می‌کند.
let favoritDestinationCache = null;
let favoritDestinationCacheAt = 0;
let favoritDestinationInFlight = null;
const FAVORIT_DESTINATION_CACHE_MS = 5 * 60 * 1000;

export const FavoritDestinationApi = async (searchData) => {
  try {
    const now = Date.now();
    if (favoritDestinationCache && now - favoritDestinationCacheAt < FAVORIT_DESTINATION_CACHE_MS) {
      return favoritDestinationCache;
    }

    if (!favoritDestinationInFlight) {
      const token = localStorage.getItem("access_token");
      favoritDestinationInFlight = axios
        .get(`${baseUrl}/ItemHomeShbinja/GetAll`, {
          params: {},
          headers: { token: token },
        })
        .then((response) => {
          favoritDestinationCache = response.data;
          favoritDestinationCacheAt = Date.now();
          return response.data;
        })
        .finally(() => {
          favoritDestinationInFlight = null;
        });
    }

    return await favoritDestinationInFlight;
  } catch (error) {
    favoritDestinationInFlight = null;
    console.log("Error:", error?.response?.data);
    return error?.response?.data;
  }
};

//دسته بندی
export const CategoryHostApi = async (searchData) => {
  try {
    // const token = localStorage.getItem("access_token");
    const response = await axios.get(`${baseUrl}/CategoryHost/GetAll`, {
      params: {},
      headers: {
        // token: token, // Add the token to the request header
      },
    });
    // console.log(response, "response");
    return response.data; // Assuming your API returns data in the response
  } catch (error) {
    console.log("Error:", error?.response?.data);
    return error?.response?.data;
  }
};

// اقامتگاه های لخظه اخری
// export const LastMinuteDiscounts = async () => {

//   try {
//     const token = localStorage.getItem("access_token");
//     const response = await axios.get(`${baseUrl}/HostTour/LastMinuteDiscounts`, {
//       headers: {
//         token: token,
//       },
//     });

//     return response?.data;
//   } catch (error) {
//     console.log("Error:", error?.response?.data);
//     return error?.response?.data;
//   }
// };

// // رزرو فوری
// export const InstantBooking = async () => {

//   try {
//     const token = localStorage.getItem("access_token");
//     const response = await axios.get(`${baseUrl}/HostTour/InstantBooking`, {
//       headers: {
//         token: token,
//       },
//     });

//     return response?.data;
//   } catch (error) {
//     console.log("Error:", error?.response?.data);
//     return error?.response?.data;
//   }
// };

//  سرچ نوع اقامتگاه
export const GetTypeHostListApi = async (searchData) => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await axios.get(`${baseUrl}/TypeHost/TypeHostList`, {
      params: {},
      headers: {
        token: token,
      },
    });
    // console.log(response, "response");
    return response.data; // Assuming your API returns data in the response
  } catch (error) {
    console.log("Error:", error?.response?.data);
    return error?.response?.data;
  }
};

// /    لیست نوع منطقه
export const GetTypeHostLocListApi = async (searchData) => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await axios.get(`${baseUrl}/TypeHostLoc/GetAll`, {
      params: {},
      headers: {
        token: token,
      },
    });
    // console.log(response, "response");
    return response.data; // Assuming your API returns data in the response
  } catch (error) {
    console.log("Error:", error?.response?.data);
    return error?.response?.data;
  }
};

// سرچ یک اقامتگاه
export const HostTourSearchOneApi = async (stayCode) => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await axios.get(
      `${baseUrl}/HostTour/GetTour/${stayCode}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data; // Assuming your API returns data in the response
  } catch (error) {
    return error?.response?.data;
  }
};

// سرچ نظرات برای یک اقامتگاه
export const HostTourSearchCommentApi = async (stayCode) => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await axios.get(
      `${baseUrl}/HostTour/ListCommentsTourForHome/${stayCode}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    // console.log(response, "response");
    return response.data; // Assuming your API returns data in the response
  } catch (error) {
    console.log("Error:", error?.response?.data);
    return error?.response?.data;
  }
};

// سرچ یک اقامتگاه برای ویرایش
export const HostTourSearchOneApiForEdit = async (guid) => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await axios.get(`${baseUrl}/HostTour/${guid}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log(response, "mklresponse");
    return response.data; // Assuming your API returns data in the response
  } catch (error) {
    console.log("Error:", error?.response?.data);
    return error?.response?.data;
  }
};

//  ایجاد یک اقامتگاه جدید
export const HostTourCreateApi = async (createData) => {
  console.log("createData", createData);

  try {
    const token = localStorage.getItem("access_token");
    const response = await axios.post(
      `${baseUrl}/HostTour`,
      {
        Title: createData?.title, // "اسم میزبان",
        TypeHostId: createData?.typeHostId, // 1, //نوع اقامت برحسب آی دی
        TypeHostLocId: createData?.typeHostLocId, //1, //منطقه اقامت برحسب آی دی
        provinceId: createData?.provinceId, //1, //استان برحسب آی دی
        cityId: createData?.cityId, //1, // شهر برحسب استان
        Start: createData?.start, //"12:00", // ساعت ورود برحسب رشته
        End: createData?.end, //"17:00", //ساعت خروج بر حسب رشته
        SizeOfTheInfrastructure: createData?.sizeOfTheInfrastructure, //120, // متراژ زیربنا
        AllSizeOfTheInfrastructure: createData?.allSizeOfTheInfrastructure, //120, // متراژ کل
        MinCapacity: createData?.minCapacity, //1, // حداقل نفرات
        MaxCapacity: createData?.maxCapacity, //1, /// حداکثر نفرات
        Room: createData?.room, //1, ///تعداد اتاف
        Bed: createData?.bed, //1, /// تعداد تخت خواب یک نفره
        BedTwo: createData?.bedTwo, //1, /// تعداد تخت خواب دونفره
        BedOld: createData?.bedOld, //1, /// تعداد تخت خواب سنتی
        BathRoom: createData?.bathRoom, //1, ///تعداد حمام
        OtherItemTourIds: createData?.otherItemTourIds, //["1", "2"], ////سایر امکانات برحسب لیست ای دی
        RolItemTourIds: createData?.rolItemTourIds, //["1", "2"], /// قوانین برحسب لیست آی دی
        Dics: createData?.dics, //"توضیحات",
        Loc: createData?.loc, //"لوکیشن",
        address: createData?.address || "", // آدرس متنی
        tell: createData?.tell || "",
        zipCod: createData?.zipCod || "",
        emergencyMobile: createData?.emergencyMobile || "",
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    // console.log(response, "response");
    return response.data; // Assuming your API returns data in the response
  } catch (error) {
    console.log("Error:", error?.response?.data);
    return error?.response?.data;
  }
};

// به روز رسانی اقامتگاه
export const HostTourUpdateApi = async (updateData, guid) => {
  console.log("myDaa", updateData);

  try {
    const token = localStorage.getItem("access_token");
    const response = await axios.post(
      `${baseUrl}/HostTour/update`,
      {
        // Id: updateData?.id,
        Guid: guid,
        Title: updateData?.title, // "اسم میزبان",
        TypeHostId: updateData?.typeHostId, // 1, //نوع اقامت برحسب آی دی
        TypeHostLocId: updateData?.typeHostLocId, //1, //منطقه اقامت برحسب آی دی
        AccommodationSpaceId: updateData?.accommodationSpaceId, // فضای اقامتگاه (دربست)
        ProvinceId: updateData?.provinceId, //1, //استان برحسب آی دی
        CityId: updateData?.cityId, //1, // شهر برحسب استان
        Start: updateData?.start, //"12:00", // ساعت ورود برحسب رشته
        End: updateData?.end, //"17:00", //ساعت خروج بر حسب رشته
        SizeOfTheInfrastructure: updateData?.sizeOfTheInfrastructure, //120, // متراژ زیربنا
        AllSizeOfTheInfrastructure: updateData?.allSizeOfTheInfrastructure, //120, // متراژ کل
        MinCapacity: updateData?.minCapacity, //1, // حداقل نفرات
        MaxCapacity: updateData?.maxCapacity, //1, /// حداکثر نفرات
        Room: updateData?.room, //1, ///تعداد اتاف
        Bed: updateData?.bed, //1, /// تعداد تخت خواب یک نفره
        BedTwo: updateData?.bedTwo, //1, /// تعداد تخت خواب دونفره
        BedOld: updateData?.bedOld, //1, /// تعداد تخت خواب سنتی
        BathRoom: updateData?.bathRoom, //1, ///تعداد حمام
        OtherItemTourIds: updateData?.otherItemTourIds || [], //["1", "2"], ////سایر امکانات برحسب لیست ای دی
        RolItemTourIds: updateData?.rolItemTourIds || [], //["1", "2"], /// قوانین برحسب لیست آی دی
        Dics: updateData?.dics, //"توضیحات",
        Loc: updateData?.loc, //"لوکیشن",
        Step: updateData?.step, //"پله ها",
        Floor: updateData?.floor, //"طلبقه ",
        Disabled: updateData?.disabled, //"مناسب سالمندان",
        cancelPercentageFirst: updateData?.cancelPercentageFirst, //آسان=0 ,متعادل=1, سختگیرانه=2
        CancelPercentageSecond: updateData?.cancelPercentageSecond,
        CancelPercentageThird: updateData?.cancelPercentageThird,
        DiscountToday: updateData?.discountToday, //"تخفیف امروز ",
        DiscountSecond: updateData?.discountSecond, //"تخفیف فردا ",
        DiscountThrid: updateData?.discountThrid, //"تخفیف پسفردا ",
        DiscountWeeky: updateData?.discountWeeky, //"تخفیف هفتگی ",
        DiscountMonth: updateData?.discountMonth, //"تخفیف ماهانه ",
        DiscountOther: updateData?.discountOther, //"تخفیف متفرقه ",
        Address: updateData?.address, //"لوکیشن",
        tell: updateData?.tell,
        zipCod: updateData?.zipCod,
        emergencyMobile: updateData?.emergencyMobile,
        // FileHost: updateData?.fileHost,
        isRole: updateData?.isRole, //updateData?.isRoleF/
        // NationallImage: updateData?.nationallImage,
        PriceHostTourBaseSpring: [
          ...updateData?.priceHostTourBaseSpring,
          ///قیمت برای بهار
          // {
          //   PeriodType: 0, ///آخر هفته=0  وسط هفته=1    تعطیلات=2
          //   priceBase: 100000,
          //   otherPrice: 0,
          // },
        ],
        PriceHostTourBaseSummer: [
          ...updateData?.priceHostTourBaseSummer,
          ////قیمت برای تابستان
          // {
          //   PeriodType: 0,
          //   priceBase: 100000,
          //   otherPrice: 0,
          // },
        ],
        PriceHostTourBaseAutum: [
          ...updateData?.priceHostTourBaseAutum,
          ////قیمت برای پاییز
          // {
          //   periodType: 0,
          //   priceBase: 100000,
          //   otherPrice: 0,
          // },
        ],
        PriceHostTourBaseWinter: [
          ...updateData?.priceHostTourBaseWinter,
          ///قیمت برای زمستان
          // {
          //   PeriodType: 0,
          //   priceBase: 100000,
          //   otherPrice: 0,
          // },
        ],
        PriceHostTourTimer: [
          ///قیمت برای زمانهای مشخص
          // {
          //   start: "2025-11-16T00:00:00Z",
          //   end: "2025-11-17T00:00:00Z",
          //   priceBase: 100000,
          //   otherPrice: 0,
          // },
        ],
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    // console.log(response, "response");
    return response.data; // Assuming your API returns data in the response
  } catch (error) {
    console.log("Error:", error?.response?.data);
    return error?.response?.data;
  }
};

// آپلود سند اقامتگاه و کد ملی کاربر اقامتگاه
export const UploadDocumentsApi = async (updateData, guid) => {
  try {
    const token = localStorage.getItem("access_token");
    console.log(updateData, "UploadDocumentsApi");
    const response = await axios.post(
      `${baseUrl}/HostTour/UploadDocuments`,
      {
        Guid: guid,
        FileHost: updateData?.fileHost,
        NationallImage: updateData?.nationallImage,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    // console.log(response, "response");
    return response.data; // Assuming your API returns data in the response
  } catch (error) {
    console.log("Error:", error?.response?.data);
    return error?.response?.data;
  }
};

// سرچ لیست اقامتگاههای من
export const MyHostTourSearchApi = async (searchData) => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await axios.get(`${baseUrl}/HostTour/List`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    // console.log(response, "response");
    return response.data; // Assuming your API returns data in the response
  } catch (error) {
    console.log("Error:", error?.response?.data);
    return error?.response?.data;
  }
};

// سرچ  تصاویر اقامتگاه
export const HostTourSearchImagesApi = async (id) => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await axios.post(
      `${baseUrl}/HostTour/ListImage/${id}`,
      {
        skip: 0,
        take: 10,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    // console.log(response, "response");
    return response.data; // Assuming your API returns data in the response
  } catch (error) {
    console.log("Error:", error?.response?.data);
    return error?.response?.data;
  }
};

// آپلود عکس برای اقامتگاه
export const HostUploadImageApi = async (imageData, stayId, onProgress) => {
  try {
    const token = localStorage.getItem("access_token");

    const response = await axios.post(
      `${baseUrl}/HostTour/Images`,
      {
        HostTourId: stayId,
        File: {
          FileName: imageData.FileName,
          Extension: imageData.Extension,
          Size: Number(imageData.Size),
          Data: `${imageData.Data}`,
        },
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        onUploadProgress: (progressEvent) => {
          if (onProgress) {
            const progress = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            onProgress(progress); // Pass the progress to the callback
          }
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error uploading image:",
      error?.response?.data || error.message
    );
    return error?.response?.data;
  }
};

// حذف عکس برای اقامتگاه
export const HostDeleteImageApi = async (guidImage) => {
  try {
    const token = localStorage.getItem("access_token");

    const response = await axios.post(
      `${baseUrl}/HostTour/DeleteImage/${guidImage}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error uploading image:",
      error?.response?.data || error.message
    );
    return error?.response?.data;
  }
};

// حذف اقامتگاه
export const HostDeleteOneApi = async (guid) => {
  try {
    const token = localStorage.getItem("access_token");

    const response = await axios.post(
      `${baseUrl}/HostTour/delete/${guid}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error uploading image:",
      error?.response?.data || error.message
    );
    return error?.response?.data;
  }
};

// رزروهای من
export const MyReservationsApi = async (state) => {
  try {
    const token = localStorage.getItem("access_token");

    const response = await axios.post(
      `${baseUrl}/HostTourOrder/ListForUser`,
      {
        states: state,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error uploading image:",
      error?.response?.data || error.message
    );
    return error?.response?.data;
  }
};

//مشاهده اطلاعات  یک اقامتگاه
export const GetInfoReserveApi = async (OrderNum) => {
  try {
    const token = localStorage.getItem("access_token");

    const response = await axios.get(`${baseUrl}/HostTourOrder/${OrderNum}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error(
      "Error uploading image:",
      error?.response?.data || error.message
    );
    return error?.response?.data;
  }
};

//محاسبه قیمت
export const PriceCalculationApi = async (
  staycode,
  startDateshamsi,
  endDateshamsi,
  count = 0
) => {
  try {
    const token = localStorage.getItem("access_token");
    var startMiladi = moment(startDateshamsi, "jYYYY/jMM/jDD").format(
      "YYYY-MM-DD"
    );
    // var endMiladi = moment(endDateshamsi, "jYYYY/jMM/jDD").format("YYYY-MM-DD");
    var endMiladi = moment(endDateshamsi, "jYYYY/jMM/jDD")
      .subtract(1, "days")
      .format("YYYY-MM-DD");
    const response = await axios.get(
      `${baseUrl}/HostTourPriceCalculation/${staycode}/${startMiladi}/${endMiladi}/${count}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error :", error?.response?.data || error.message);
    return error?.response?.data;
  }
};

// لیست قیمتهای اقامتگاه
export const PriceHostTourListApi = async (id, numMonth) => {
  try {
    const token = localStorage.getItem("access_token");

    const response = await axios.get(
      `${baseUrl}/PriceHostTour/GetAll/${id}/${numMonth}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error uploading image:",
      error?.response?.data || error.message
    );
    return error?.response?.data;
  }
};

// ث3بت درخواست رزرو با ارسال مشخصات
export const RequestToReserveApi = async (data) => {
  try {
    const token = localStorage.getItem("access_token");
    var startMiladi = moment(data?.start, "jYYYY/jMM/jDD").format("YYYY-MM-DD");
    // var endMiladi = moment(endDateshamsi, "jYYYY/jMM/jDD").format("YYYY-MM-DD");
    var endMiladi = moment(data?.end, "jYYYY/jMM/jDD")
      .subtract(1, "days")
      .format("YYYY-MM-DD");

    const myData = {
      hostTourId: data?.hostTourId,
      startDate: startMiladi,
      endDate: endMiladi,
      personCount: data?.personCount,
      fullName: data?.fullName,
      mobile: data?.mobile,
    };
    console.log(myData, "befor request", data);
    const response = await axios.post(
      `${baseUrl}/HostTourOrder/Create`,
      {
        // userId: 1,
        ...myData,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error uploading image:",
      error?.response?.data || error.message
    );
    return error?.response?.data;
  }
};
